import React from "react";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import get from "lodash/get";
import Padder from "components/Padder";
import Toggle from "react-toggle";
import MenuNavHeader from "components/MenuNavHeader";
import ImageField from "components/ImageField";
import { getToggleProps } from "utils/form";
import TextareaController from "components/TextareaController";

const PresentationSettings = (props) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();

  const name = props.name;
  const configPath = `${name}.config`;
  const rootPath = `${name}.data`;
  const content = get(values, rootPath, {});

  /**
   * Brand header on preview section
   */
  const showBrandPath = `${configPath}.${STATE_KEYS.ENTITY_CONFIG.BRAND_SHOW}`;
  const showBrandTouched = get(touched, showBrandPath);
  const showBrand = Boolean(get(values, showBrandPath));

  const showInitialPreviewPath = `${configPath}.${STATE_KEYS.ENTITY_CONFIG.INITIAL_PREVIEW_SHOW}`;
  const showInitialPreviewTouched = get(touched, showInitialPreviewPath);
  const showInitialPreview = Boolean(get(values, showInitialPreviewPath));

  return (
    <div className="w-100">
      <MenuNavHeader label="Presentation" />
      <div className="pt3 bh--inset">
        <div className="f5 ph3 pb3 fw6">Brand</div>
        <div className="ph3 bg-white h-100 bh--inset dib w-100 pb3 bb hairline-1">
          <div className="w-100 flex flex-column">
            <div className="w-100 flex flex-row justify-between items-center">
              <label className="f6 dib fw6">Show</label>
              <Toggle
                {...getToggleProps({
                  active: showBrand,
                  setFieldValue: (_, active) => {
                    setFieldValue(showBrandPath, active);
                    if (!showBrandTouched) {
                      setFieldTouched(showBrandPath, true);
                    }
                  }
                })}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="pt3 bh--inset">
        <div className="f5 ph3 pb2 fw6">Initial preview</div>
        <div className="f7 ph3 pb3 lh-copy">
          Shown when no products have been added to the checkout cart.
        </div>
        <div className="ph3 bg-white h-100 bh--inset dib w-100 pb3">
          <div className="w-100 flex flex-column">
            <div className="w-100 flex flex-row justify-between items-center">
              <label className="f6 dib fw6">Show</label>
              <Toggle
                {...getToggleProps({
                  active: showInitialPreview,
                  setFieldValue: (_, active) => {
                    setFieldValue(showInitialPreviewPath, active);
                    if (!showInitialPreviewTouched) {
                      setFieldTouched(showInitialPreviewPath, true);
                    }
                  }
                })}
              />
            </div>
          </div>
        </div>
        <ImageField
          name={`${rootPath}.initialPreview.image`}
          image={content.initialPreview && content.initialPreview.image}
          uploadPrompt="Upload an image"
        />
        <div className="ph3 bg-white h-100 bh--inset">
          <div className="pt3">
            <TextareaController
              name="title"
              key={`${rootPath}.initialPreview.title`}
              label="Name"
              rootPath={`${rootPath}.initialPreview`}
              fieldKey="title"
              minRows={1}
            />
          </div>
          <div className="pt3">
            <TextareaController
              key={`${rootPath}.initialPreview.subtitle`}
              name="subtitle"
              label="Subtitle"
              rootPath={`${rootPath}.initialPreview`}
              fieldKey="subtitle"
              minRows={1}
            />
          </div>
        </div>
      </div>

      <Padder theme="visible" />
    </div>
  );
};

export default PresentationSettings;
